<template>
  <div
    class="drag-warpper"
    draggable="true"
    @mousedown="onmousedown"
    @dragstart="ondragstart"
    @dragover="ondragover"
    @dragenter="ondragenter"
    @dragleave="ondragleave"
    @drop="ondrop"
    @dragend="ondragend"
  >
    <slot>drag</slot>
  </div>
</template>

<script>
export default {
  props:['dragTarget','dragData'],
  data() {
    return {
      draging: false
    };
  },
  methods: {
    onmousedown() {
      /* 兼容ie8 */
      if (this.dragDrop) {
        this.dragDrop();
      }
    },
    ondragstart(e) {
      /* 清空原始数据 */
      e.dataTransfer.clearData()
      e.dataTransfer.setData('text',this.dragData)
    },
    ondragover(e) {

    },
    ondragenter(e){

    },
    ondragleave(e){

    },
    ondrop(e){

    },
    ondragend(e) {

    }
  },
  components: {}
};
</script>

<style lang="less" scoped>
.drag-warpper {
}
</style>

